import { FormControl, FormField, FormItem } from "@/src/components/ui/form";
import { FiltersFormT } from "./filters.schema";
import { Combobox } from "../../../components/ui/combobox";
import { useState } from "react";
import { fetch } from "@/src/lib/fetch";

type Operator = {
  name: string;
};

export const Operator = ({ defaultValue }: { defaultValue?: Operator["name"] }) => {
  const [operator, setOperator] = useState<Operator | null>(defaultValue ? { name: defaultValue } : null);

  return (
    <div className="w-full">
      <h3 className="text-lg font-semibold col-span-full mb-10">Operator</h3>
      <FormField<FiltersFormT, "operator">
        name="operator"
        render={({ field }) => {
          return (
            <FormItem>
              <FormControl>
                <Combobox
                  className="flex w-96"
                  loadOptions={(query) =>
                    fetch<{ data: Operator[] }>(`/api/operators/operators?pageSize=5&filter=${query}`).then(
                      (r) => r.data,
                    )
                  }
                  placeholder="Search for operator..."
                  value={operator}
                  onChange={(v) => {
                    if (v && v.name !== operator?.name) {
                      setOperator(v);
                      field.onChange(v.name);
                    } else {
                      setOperator(null);
                      field.onChange("");
                    }
                  }}
                  renderOption={(r) => r.name}
                />
              </FormControl>
            </FormItem>
          );
        }}
      />
    </div>
  );
};
